//Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
vue.use(vuex);


//store
const tipoclasificador = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/tipoclasificador`,
    state: {
        tipoclasificadores: [],
        tipoclasificadorfiltrado:[]
    }
}).get({
    action: "get_tiposclasificador",      
    onSuccess: (state, payload ) => {
        state.tipoclasificadores = payload.data;
    }
}).get({
    action: "get_tiposclasificadorbyindicador", 
    path: function (obj) {
        return `/getclasificador/${obj.IdIndicador}`;
    },     
    onSuccess: (state, payload ) => {
        state.tipoclasificadorfiltrado = payload.data;
    }
}).getStore();

tipoclasificador.getters = {
    gtiposclasificador: state => {
        return state.tipoclasificadores;
    },
    gtiposclasificadorfiltrado: state => {
        return state.tipoclasificadorfiltrado;
    }
}

export default tipoclasificador;